import { PipeTransform } from '@angular/core';
import { HomeUrlHelper } from '@sc/pas-common';
var SideBarLinkPipe = /** @class */ (function () {
    function SideBarLinkPipe(urlHelper) {
        this.urlHelper = urlHelper;
    }
    SideBarLinkPipe.prototype.transform = function (link, origin) {
        if (origin === void 0) { origin = ''; }
        return this.urlHelper.urlByOrigin(link, origin);
    };
    return SideBarLinkPipe;
}());
export { SideBarLinkPipe };
